module.exports = __webpack_public_path__ + "static/media/step1.91e26d77.jpeg";